export default __webpack_public_path__ + "static/media/cb32e542f7c52aa973e75dcf2ce2f967.svg";